/*=========================================================================================
  File Name: moduleUserFileState.js
  Description: UserFile Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    userFileList: [],
    userFileListCount: "",

    fileDownloadHistoryList: [],
    fileDownloadHistoryCount: "",

    fileRecvHistoryList: [],
    fileRecvHistoryCount: ""
}